import axios from "axios";
import { store as storeNotification } from "react-notifications-component";
import {
	COMPANY_SAVED,
	COMPANY_SAVING,
	COMPANY_SAVING_FAILED,
	COMPANY_SAVING_INITIALIZE,
} from "./types";
export const companySave = (listdata) => (dispatch) => {
	dispatch({ type: COMPANY_SAVING });
	storeNotification.addNotification({
		title: "savingCompany",
		message: "System is Signing Doc...",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});

	console.log("docSubmit data=", listdata);
	let formData = new FormData(); //formdata object

	var listItems = listdata.data.map((listdata) => {
		formData.append(listdata.name, listdata.value); //append the values with key, value pair
	});

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	axios
		.post(listdata.url, formData, config)
		.then((response) => {
			dispatch({ type: COMPANY_SAVED, payload: response });
			storeNotification.addNotification({
				title: "Submit!",
				message: "Succefull Signed Doc",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Signing!",
				message: "failed to Sign Doc",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: COMPANY_SAVING_FAILED,
				payload: error,
			});
		});
};

export const companyUpdate = (listdata) => async (dispatch) => {
	await dispatch({ type: COMPANY_SAVING });
	await storeNotification.addNotification({
		title: "updating",
		message: "System is Upadating Company...",
		type: "success",
		insert: "top",
		container: "top-right",
		animationIn: ["animated", "fadeIn"],
		animationOut: ["animated", "fadeOut"],
		dismiss: {
			duration: 5000,
			onScreen: true,
		},
	});

	console.log("company Submit data=", listdata);

	const token = localStorage.getItem("token");
	const config = {
		headers: {
			"x-auth-token": token,
			"content-type": "application/json",
		},
	};

	await axios
		.post(listdata.url, listdata.data, config)
		.then((response) => {
			dispatch({ type: COMPANY_SAVED, payload: response });
			storeNotification.addNotification({
				title: "Updating!",
				message: "Succefull updated Company",
				type: "success",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});

			console.log("response.data=", response.data);
		})
		.catch((error) => {
			console.log(error);
			storeNotification.addNotification({
				title: "Updating!",
				message: "failed to Update Company",
				type: "danger",
				insert: "top",
				container: "top-right",
				animationIn: ["animated", "fadeIn"],
				animationOut: ["animated", "fadeOut"],
				dismiss: {
					duration: 5000,
					onScreen: true,
				},
			});
			return dispatch({
				type: COMPANY_SAVING_FAILED,
				payload: error,
			});
		});
};

export const companySaveInitialize = (listdata) => (dispatch) => {
	dispatch({ type: COMPANY_SAVING_INITIALIZE });
};
